export const DEFAULT_TRANSPARENT = false;
export const DEFAULT_CLASS_NAME = '';
